import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import queryString from "query-string"
import {
  useLocation,
  withRouter,
  useParams,
  useHistory,
} from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Alert,
  Modal,
  Label,
  Collapse,
} from "reactstrap"
import { AvForm } from "availity-reactstrap-validation"
import Dropzone from "react-dropzone"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

import { useDispatch, useSelector } from "react-redux"
import {
  addTrackingImage,
  addTrackingImageError,
  deleteTracking,
  deleteTrackingImage,
  getTracking,
  resetTrackingData,
  resetTrackingFlag,
  resetTrackingImageFlag,
} from "store/actions"
import { toast } from "react-toastify"
import ContainerCollapse from "components/Common/ContainerCollapse"
import classnames from "classnames"

const TrackingEdit = props => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const params = queryString.parse(location.search)

  const { trackingUid } = useParams()
  const {
    tracking,
    trackingSuccess,
    trackingError,
    loading,
    loadingSubmit,
    loadingTrackingImageSubmit,
    trackingImageSuccess,
    trackingImageError,
    currentUser,
  } = useSelector(state => ({
    tracking: state.Trackings.tracking,
    trackingSuccess: state.Trackings.success,
    trackingError: state.Trackings.error,
    loading: state.Trackings.loading,
    loadingSubmit: state.Trackings.loadingSubmit,
    loadingTrackingImageSubmit: state.TrackingImages.loadingSubmit,
    trackingImageSuccess: state.TrackingImages.success,
    trackingImageError: state.TrackingImages.error,
    currentUser: state.Login.user,
  }))

  const [photoIndex, setphotoIndex] = useState(0)
  const [isGallery, setisGallery] = useState(false)
  const [images, setImages] = useState([])
  const [imageUploads, setImageUploads] = useState([])
  const [imageSelected, setImageSelected] = useState({})

  useEffect(() => {
    dispatch(resetTrackingData())
    dispatch(
      getTracking(trackingUid, params.bookingNo || "", params.containerNo || "")
    )
  }, [])

  useEffect(() => {
    if (trackingImageSuccess) {
      toast.dismiss()
      toast.success(trackingImageSuccess)
      setModalUpload(false)
      setModalConfirmDelete(false)
      dispatch(resetTrackingImageFlag())
      dispatch(
        getTracking(
          trackingUid,
          params.bookingNo || "",
          params.containerNo || ""
        )
      )
    }
  }, [trackingImageSuccess])

  useEffect(() => {
    if (trackingSuccess) {
      toast.dismiss()
      toast.success(trackingSuccess)
      setModalConfirmDeleteTracking(false)
      dispatch(resetTrackingFlag())
      history.replace("/tracking-list")
    }
  }, [trackingSuccess])

  useEffect(() => {
    if (tracking && tracking.images && tracking.images.length > 0)
      setImages([...tracking.images])
    else setImages([])
  }, [tracking])

  const [modalUpload, setModalUpload] = useState(false)
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false)

  function toggleModalUpload() {
    setModalUpload(!modalUpload)
    setImageUploads([])
  }

  function toggleModalConfirmDelete() {
    setModalConfirmDelete(!modalConfirmDelete)
  }

  function handleFormSubmit(event, values) {
    if (imageUploads.length === 0) {
      dispatch(addTrackingImageError("Please upload some image !"))

      setTimeout(() => {
        dispatch(resetTrackingImageFlag())
      }, 5000)
      return
    }
    const form = new FormData()
    form.append("tracking_uid", tracking.uid)
    for (let img of imageUploads) {
      form.append("images[]", img.original)
    }

    dispatch(addTrackingImage(form))
  }

  function handleDelete(imageObj) {
    setImageSelected(imageObj)
    toggleModalConfirmDelete()
  }

  function handleDeleteSubmit() {
    dispatch(deleteTrackingImage(imageSelected))
  }

  function handleAcceptedFiles(files) {
    for (let file of files) {
      if (!validateImageType(file)) {
        dispatch(
          addTrackingImageError(
            "Invalid file extension, shoud be .png or .jpeg."
          )
        )
        setTimeout(() => {
          dispatch(resetTrackingImageFlag())
        }, 5000)
        return
      }
    }

    const fileArray = files.map(file => {
      return {
        original: file,
        name: file.name,
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }
    })
    setImageUploads([...imageUploads, ...fileArray])
  }

  function handleRemoveImageUpload(index) {
    const newImageUploads = imageUploads.filter((item, i) => i !== index)
    setImageUploads([...newImageUploads])
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  function validateImageType(file) {
    const type = file.type.split("/")
    if (type[0] !== "image") return false
    if (type[1] !== "png" && type[1] !== "jpeg" && type[1] !== "jpg")
      return false
    return true
  }

  function imageName(imgUrl) {
    const url = imgUrl.split("/")
    const name = url[url.length - 1].split(".")
    return name[0]
  }

  const [modalConfirmDeleteTracking, setModalConfirmDeleteTracking] =
    useState(false)

  function toggleModalConfirmDeleteTracking() {
    dispatch(resetTrackingFlag())
    setModalConfirmDeleteTracking(!modalConfirmDeleteTracking)
  }

  function handleDeleteTracking() {
    toggleModalConfirmDeleteTracking()
  }

  function handleDeleteSubmitTracking() {
    dispatch(deleteTracking(tracking))
  }

  return (
    <React.Fragment>
      {isGallery ? (
        <Lightbox
          mainSrc={images[photoIndex].image_display}
          nextSrc={images[(photoIndex + 1) % images.length].image_thumb}
          prevSrc={
            images[(photoIndex + images.length - 1) % images.length].image_thumb
          }
          enableZoom={true}
          onCloseRequest={() => {
            setisGallery(false)
          }}
          onMovePrevRequest={() => {
            setphotoIndex((photoIndex + images.length - 1) % images.length)
          }}
          onMoveNextRequest={() => {
            setphotoIndex((photoIndex + 1) % images.length)
          }}
          imageCaption={imageName(images[photoIndex].image_display)}
        />
      ) : null}

      <div className="page-content">
        <MetaTags>
          <title>Hast | Edit Tracking</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex flex-wrap mt-2 mb-3">
            <div className="col-8">
              <div className="d-inline-block">
                <span className="h4">Edit Tracking</span>
              </div>
            </div>
            <div className="col-4 text-end">
              <Button
                outline
                color="danger"
                onClick={() => handleDeleteTracking()}
              >
                Delete this tracking
              </Button>
            </div>
          </div>

          {tracking && (
            <>
              <section id="header-section">
                <Row>
                  <Col xs="6" sm="3" md="2">
                    <span className="font-weight-light">Booking No.</span>
                    <h4 className="font-size-16">
                      {tracking.booking_no || ""}
                    </h4>
                  </Col>
                  <Col  xs="6" sm="3" md="2">
                    <span className="font-weight-light">Container No.</span>
                    <h4 className="font-size-16">
                      {tracking.container_no || ""}
                    </h4>
                  </Col>
                  <Col xs="6" sm="3" md="2">
                    <span className="font-weight-light">Type</span>
                    <h4 className="font-size-16">
                      <small
                        style={{
                          width: "50px",
                        }}
                        className={classnames("badge py-2", {
                          "bg-success": tracking.type === "in",
                          "bg-warning": tracking.type === "out",
                        })}
                      >
                        {tracking.type.toUpperCase()}
                      </small>
                    </h4>
                  </Col>
                </Row>
              </section>
              <section id="container-info-section">
                <ContainerCollapse containerInfo={tracking.containerInfo} />
              </section>
              <section id="images-section">
                <div className="mt-4 mb-3">
                  <span className="h4 font-size-16 ">
                    Images {images.length > 0 && ` (${images.length})`}
                  </span>
                  {tracking && currentUser && currentUser.is_admin && (
                    <Button
                      className="ms-3"
                      color="primary"
                      outline
                      size="sm"
                      onClick={() => {
                        toggleModalUpload()
                      }}
                      data-toggle="modal"
                      data-target=".bs-example-modal-center"
                    >
                      Upload Image
                    </Button>
                  )}
                </div>

                {images.length === 0 && (
                  <Row>
                    <span>No Image Uploaded.</span>
                  </Row>
                )}
                {images.length > 0 && (
                  <>
                    <div className="popup-gallery d-flex flex-wrap mt-4">
                      <Row className="w-100">
                        {images.map((img, index) => (
                          <Col xl="3" sm="6" key={img.uid}>
                            <Card
                              className="text-center"
                              style={{ width: "100%" }}
                            >
                              <CardBody>
                                <img
                                  className=""
                                  style={{ width: "100%", cursor: "pointer" }}
                                  src={img.image_thumb}
                                  alt={imageName(img.image_thumb)}
                                  onClick={() => {
                                    setisGallery(true)
                                    setphotoIndex(index)
                                  }}
                                />
                                <Row className="m-0 mt-2">
                                  <Col
                                    className={
                                      currentUser && currentUser.is_admin
                                        ? "text-start p-0"
                                        : "text-center p-0"
                                    }
                                    style={{
                                      wordWrap: "break-word",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    {imageName(img.image_thumb)}
                                  </Col>
                                  {currentUser && currentUser.is_admin && (
                                    <Col xs="2" sm="2" className="text-end p-0">
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleDelete(img)}
                                      >
                                        <i className="bx bx-trash"></i>
                                      </button>
                                    </Col>
                                  )}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </>
                )}
              </section>

              <Modal isOpen={modalUpload} centered={true}>
                <div className="modal-header">
                  <h5 className="modal-title mt-0">Upload Image</h5>
                  <button
                    type="button"
                    onClick={() => {
                      setModalUpload(false)
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    disabled={loadingTrackingImageSubmit}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {trackingImageError ? (
                    <Alert color="danger">{trackingImageError}</Alert>
                  ) : null}
                  <AvForm
                    className="form-horizontal"
                    id="upload-images-form"
                    onValidSubmit={(e, v) => {
                      handleFormSubmit(e, v)
                    }}
                  >
                    <div className="mb-2">
                      <Dropzone
                        onDrop={acceptedFiles => {
                          handleAcceptedFiles(acceptedFiles)
                        }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="dropzone">
                            <div
                              className="dz-message needsclick mt-2"
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div className="mb-3">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                              </div>
                              <h4>Drop images here or click to upload.</h4>
                            </div>
                          </div>
                        )}
                      </Dropzone>
                      <div
                        className="dropzone-previews mt-3"
                        id="file-previews"
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        {imageUploads.map((f, i) => {
                          return (
                            <Card
                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                              key={i + "-file"}
                            >
                              <div className="p-2">
                                <Row className="align-items-center">
                                  <Col className="col-auto">
                                    <img
                                      data-dz-thumbnail=""
                                      height="80"
                                      className="avatar-sm rounded bg-light"
                                      alt={f.name}
                                      src={f.preview}
                                    />
                                  </Col>
                                  <Col
                                    style={{
                                      wordWrap: "break-word",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    <span className="text-muted font-weight-bold">
                                      {f.name}
                                    </span>
                                    <p className="mb-0">
                                      <strong>{f.formattedSize}</strong>
                                    </p>
                                  </Col>
                                  <Col className="text-end" xs="2" sm="2">
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => handleRemoveImageUpload(i)}
                                    >
                                      <i className="bx bx-trash"></i>
                                    </button>
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          )
                        })}
                      </div>
                    </div>
                  </AvForm>
                </div>
                <div className="modal-footer">
                  <div className="row w-100">
                    <div className="col-6">
                      <button
                        type="button"
                        className="btn btn-outline-secondary "
                        onClick={() => {
                          toggleModalUpload()
                        }}
                        disabled={loadingTrackingImageSubmit}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-6 text-end">
                      <button
                        type="submit"
                        form="upload-images-form"
                        className="btn btn-success"
                        disabled={loadingTrackingImageSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>
              <Modal isOpen={modalConfirmDelete} centered={true}>
                <div className="modal-header">
                  <h5 className="modal-title mt-0">Confirm Delete</h5>
                  <button
                    type="button"
                    onClick={() => {
                      setModalConfirmDelete(false)
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    disabled={loadingTrackingImageSubmit}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {trackingImageError ? (
                    <Alert color="danger">{trackingImageError}</Alert>
                  ) : null}

                  <Row
                    className="mb-3 mt-3 ms-0 me-0"
                    style={{ wordWrap: "break-word", wordBreak: "break-all" }}
                  >
                    <span>Delete Image</span>
                    <h4 className="text-danger">
                      {imageName(imageSelected.image_thumb || "")} ?
                    </h4>
                  </Row>
                </div>
                <div className="modal-footer">
                  <div className="row w-100">
                    <div className="col-6">
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => {
                          toggleModalConfirmDelete()
                        }}
                        disabled={loadingTrackingImageSubmit}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-6 text-end">
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDeleteSubmit()}
                        disabled={loadingTrackingImageSubmit}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>
              <Modal isOpen={modalConfirmDeleteTracking} centered={true}>
                <div className="modal-header">
                  <h5 className="modal-title mt-0">Confirm Delete</h5>
                  <button
                    type="button"
                    onClick={() => {
                      setModalConfirmDeleteTracking(false)
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    disabled={loadingSubmit}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {trackingError ? (
                    <Alert color="danger">{trackingError}</Alert>
                  ) : null}

                  <Row
                    className="mb-3 mt-3 ms-0 me-0"
                    style={{ wordWrap: "break-word", wordBreak: "break-all" }}
                  >
                    <Col>
                      <span className="font-weight-light">Booking No.</span>
                      <h4 className="font-size-16">
                        {tracking.booking_no || ""}
                      </h4>
                    </Col>
                    <Col>
                      <span className="font-weight-light">Container No.</span>
                      <h4 className="font-size-16">
                        {tracking.container_no || ""}
                      </h4>
                    </Col>
                  </Row>
                </div>
                <div className="modal-footer">
                  <div className="row w-100">
                    <div className="col-6">
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => {
                          toggleModalConfirmDeleteTracking()
                        }}
                        disabled={loadingSubmit}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-6 text-end">
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDeleteSubmitTracking()}
                        disabled={loadingSubmit}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>
            </>
          )}

          {!tracking && (
            <Row className="text-center">
              <Col>Not found data.</Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(TrackingEdit)
